import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { defineComponent, reactive, ref, watch, onMounted } from "vue";
import Breads from "@/components/Breads/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { useStore } from "vuex";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { Location, Document, Menu as IconMenu, Setting } from "@element-plus/icons";
export default defineComponent({
  name: "MultiColumn",
  components: {
    Breads: Breads,
    Location: Location,
    Document: Document,
    Setting: Setting,
    IconMenu: IconMenu,
    Pagination: Pagination
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var nam = ref("");
    var loading = ref(true);
    var keys = ref("");
    var iconFlag = reactive({
      //列表
      list: [{
        children: [],
        columnName: "",
        isleaf: false
      }],
      tableData: []
    }); //分页器参数

    var theInterfaceName = ref(""); //接口名

    var parameterDTO = reactive({
      parameter: {
        pageIndex: 1
      }
    }); //参数

    var allPath = reactive([//面包屑
    {
      name: "信息咨询"
    }]);
    var route = useRoute();
    var store = useStore();
    iconFlag.list = store.state.column.column; // iconFlag.list.shift()

    var num = ref(1);
    num.value = Number(route.query.two) - 1;
    var show = reactive({
      //控制默认选中
      one: Number(route.query.stair) - 1,
      two: route.query.son
    });
    show.one = Number(route.query.stair) - 1;
    var addnumber = 0;
    var time = setInterval(function () {
      addnumber++;
      alllist;

      if (addnumber == 1) {
        show.two = route.query.son;
        clearInterval(time);
      }
    }, 100);
    onMounted(function () {
      console.log(iconFlag.list);
      test(iconFlag.list[show.one].children, show.two);
    });
    var keyone = ref("");

    function test(obj, son) {
      console.log(obj, "sjj"); //选择要渲染的列表

      allPath[0].name = iconFlag.list[show.one].columnName; //面包屑

      obj.forEach(function (element) {
        if (element.isleaf) {
          test(element.children, son);
        } else {
          if (element.keyAssignments == son) {
            element.param.columnId = element.columnId;
            keyone.value = element.keyAssignments;
            theInterfaceName.value = element.apiurl; //接口名

            parameterDTO.parameter = element.param;
            alllist(element.apiurl, element.param);
            nam.value = element.columnName;
          }
        }
      });
    }

    var handleClose = function handleClose() {
      test(iconFlag.list[show.one].children, show.two);
    };

    function showlist(val) {
      var addnumber = 0;
      var time = setInterval(function () {
        addnumber++;

        if (addnumber == 1) {
          show.two = val.query.son;
          clearInterval(time);
        }
      }, 100);
      test(iconFlag.list[show.one].children, val.query.son);
    }

    onBeforeRouteUpdate(function (to) {
      keys.value = String(to.query.son);
      totalNum.value = 10;
      show.one = Number(to.query.stair) - 1;
      showlist(to);
    });
    watch(function () {
      return route.path;
    }, function (v1) {
      if (v1 == '/multiColumn') {
        //监听地址
        show.one = Number(route.query.stair) - 1;
        showlist(route);
      }
    });
    watch(function () {
      return route.query;
    }, function (v1) {
      keys.value = String(v1.son);
    });

    var select = function select(key) {
      console.log(key, "key");
      parameterDTO.parameter.pageIndex = 1;
      test(iconFlag.list[show.one].children, key);
      totalNum.value = 10; // parameterDTO.parameter.pageIndex = 1;

      keys.value = key; //选中一级栏目时
    }; //展开
    //列表请求


    var totalNum = ref(10); //页码

    function alllist(_x, _x2) {
      return _alllist.apply(this, arguments);
    } //分页器


    function _alllist() {
      _alllist = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(names, val) {
        var list;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // newsList
                console.log(val);

                if (names == "newsList") {
                  val.draft = 1;
                }

                loading.value = true;
                _context.next = 5;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[names](val);

              case 5:
                list = _context.sent;

                if (keyone.value) {
                  show.two = keyone.value;
                  list.data.forEach(function (item) {
                    item["keyAssignments"] = keyone.value;
                  });
                }

                if (list.code == 0) {
                  iconFlag.tableData = list.data;
                  totalNum.value = list.total;
                  loading.value = false;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _alllist.apply(this, arguments);
    }

    function changPage(val) {
      parameterDTO.parameter.pageIndex = val;
      alllist(theInterfaceName.value, parameterDTO.parameter);
    } //跳转详情页


    keys.value = String(route.query.son);
    var router = useRouter();

    function jump(val) {
      var url = "";
      var category = 1;

      if (route.query.stair == "2" && keys.value.split("-")[0] == "2") {
        //1 代表信息讯的位置 keys代表新闻所在的栏目的位置
        url = "newDetails"; //新闻接口

        category = 1;
        router.push({
          path: "/details",
          query: {
            newsId: val.newsId,
            interfaceName: url,
            pass: 0,
            category: category,
            name: iconFlag.list[String(show.one)].columnName,
            stai: show.one + 1,
            son: keys.value
          }
        });
      } else {
        url = "allDetails";
        category = 3;
        router.push({
          path: "/details",
          query: {
            newsId: val.newsId,
            interfaceName: url,
            pass: 0,
            category: category,
            // name:'2',
            name: iconFlag.list[String(show.one)].columnName,
            stai: show.one + 1,
            son: keys.value,
            nam: nam.value
          }
        });
      }
    }

    return {
      allPath: allPath,
      select: select,
      iconFlag: iconFlag,
      route: route,
      num: num,
      show: show,
      nam: nam,
      alllist: alllist,
      changPage: changPage,
      totalNum: totalNum,
      theInterfaceName: theInterfaceName,
      parameterDTO: parameterDTO,
      // columist,
      // colum,
      // requrelist,
      jump: jump,
      handleClose: handleClose,
      keys: keys,
      loading: loading
    };
  }
});